<div mdbModal class="modal fade " id="scrollModal" tabindex="-1"
 role="dialog" aria-labelledby="myModalLabel" >
      <div class="modal-dialog  modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">

                  <!--Header-->
                  <div class="modal-header  darken-3 justify-content-center heading ">

                        <h4 class="title text-uppercase font-weight-bold ">
                              {{modalHeader}}
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" 
                        aria-label="Close" (click)="modalRef.hide()" #closeModal>
                              <span aria-hidden="true">&times;</span>
                        </button>

                  </div>
                  <!--Body-->
                  <div class="modal-body  text-center">

                        <div class="d-flex justify-content-center">
                              <div class="d-flex justify-content-center adjust" *ngIf="loading">

                                    <div class="loader" id="loader-4">
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                    </div>
                              </div>
                        </div>


                        <div class="row d-flex justify-content-center">

                              <div class="col-md-10 d-flex mb-3">
                                    <h6>

                                          <small class="text-muted">{{modaldescription}}</small>
                                    </h6>
                              </div>
                        </div>

                        <div class="row d-flex justify-content-center">
                              <!--Grid column-->
                              <div class="col-lg-6 col-md-6 waves-light" mdbWavesEffect>

                                    <!--Panel-->
                                    <div class="card justify-content-center">
                                          <div class="card-header text-uppercase font-weight-bold" style="background: none; border: none; text-align: left;">
                                                <h5 class="text-uppercase font-weight-bold ">
                                                      {{standardModuleHeader}}
                                                </h5>

                                          </div>
                                          <div class="card-block">
                                                <div class="col mx-1 wow fadeInUp ">
                                                      <div *ngFor="let value of arrStandartModuleContents" class="list-group-item d-flex align-items-center">
                                                            <i class="fas fa-check-circle iconColor mr-1 margin"></i>
                                                            <h6 class="align"> {{value}}</h6>
                                                      </div>
                                                </div>
                                                <div class="col  wow fadeInUp" *ngIf="shownote">
                                                      <h6 class="text-break descText textfadecolor  notecolor">
                                                            Note: All the Standard SAP ECC modules listed under SAP ECC Core Offerings are covered under this analysis.

                                                      </h6>
                                                </div>
                                          </div>
                                    </div>
                                    <!--/.Panel-->

                              </div>

                              <div class="col-lg-6 col-md-6 waves-light dottedBorder" mdbWavesEfect>

                                    <!--Panel-->
                                    <div class="card justify-content-center">
                                          <div class="card-header text-uppercase font-weight-bold" style="background: none; border: none; text-align: left;">
                                                <h5 class="text-uppercase font-weight-bold ">{{relatedLinksheader}}
                                                </h5>
                                          </div>

                                          <div class="card-block">
                                                <div class="list-group-item d-flex align-items-center" *ngIf="showofferingDeck">

                                                      <i class="fas fa-file-download iconColor mr-1 margin"></i>


                                                      <a href="{{url}}" target="_blank" (click)="onNavigate1('offering')" rel="noopener noreferrer" class="alink active" mdbTooltip="Click to open" placement="right">
                                                            <h6>{{offeringDeckText}}

                                                            </h6>
                                                      </a> 
                                                </div>
                                                <div class="list-group-item d-flex align-items-center ">

                                                      <i class="fa fa-link iconColor mr-1 margin" aria-hidden="true"></i>

                                                    

                                                      <a href="{{url}}" target="_blank" (click)="onNavigate1('demoLink')" rel="noopener noreferrer" class="alink active" mdbTooltip="Click to open" placement="right">
                                                            <h6>Demo Link

                                                            </h6>
                                                      </a>


                                                </div>
                                                <div class="list-group-item d-flex align-items-center">

                                                      <i class="fa fa-link iconColor mr-1 margin" aria-hidden="true"></i>
                                                      <a data-toggle="modal" data-target="#scrollDocket1" 
                                                      class="alink active wow fadeInUp" href="#" mdbTooltip="Click to open" placement="right" (click)="OpenDisclaimerpopup()">
                                                            <h6>Pre-Requisite Docket

                                                            </h6>
                                                      </a>




                                                </div>
                                                <div class="card-header text-uppercase font-weight-bold" style="background: none; border: none; text-align: left;">
                                                      <h5 class="text-uppercase font-weight-bold ">{{deliverables}}
                                                      </h5>
                                                </div>
                                                <div class="list-group-item d-flex align-items-center " *ngIf="showOutputDeck">

                                                      <i class="fas fa-file-download iconColor mr-1 margin"></i>
                                                      <a href="javascript:void(0)" (click)="downloadFile('OutputDeck')" class="alink active" mdbTooltip="Click to download" placement="right">
                                                            <h6>Sample Output Deck

                                                            </h6>
                                                      </a>
                                                </div>
                                                <div class="list-group-item d-flex align-items-center ">

                                                      <i class="fas fa-file-download iconColor mr-1 margin"></i>
                                                      <a href="javascript:void(0)" (click)="downloadFile('offlineReport')" class="alink active" mdbTooltip="Click to download" placement="right">
                                                            <h6>Sample Offline Reports

                                                            </h6>
                                                      </a>
                                                </div>
                                                <div class="list-group-item d-flex align-items-center ">

                                                      <i class="fa fa-link iconColor mr-1 margin" aria-hidden="true"></i>
                                                      <a href="{{url}}" target="_blank" (click)="onNavigate1('appLink')" rel="noopener noreferrer" class="alink active title" mdbTooltip="Click to open" placement="right">
                                                            <h6>Sample Reports (Online ASD Portal)

                                                            </h6>
                                                      </a>
                                                </div>

                                                <div id="success" class="toast-alert alert-success hide mt-3 " role="alert" data-delay="1000" data-autohide="true" aria-live="assertive" aria-atomic="true">


                                                                  <div class="toast-body">
                                                                        <i class="fa fa-check" aria-hidden="true"></i>
                                                                        {{alertMsg}}
                                                                  </div>
                                                            </div>

                                                            <div id="filedownloadmodalsuccess" class="toast-alert alert-info hide mt-3 " role="alert" 
                                                            aria-live="assertive" aria-atomic="true" data-autohide="false" *ngIf="showFileDownloadInfo">
                                                                  
                                                                  <div class="toast-body">
                                                                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                                        {{alertMsg}}
                                                                  </div>
                                                            </div>
                                                            <div id="error" class="toast-alert alert-danger hide mt-3" role="alert" data-delay="5000" data-autohide="true" aria-live="assertive" aria-atomic="true">

                                                                  <div class="toast-body">
                                                                        <i class="fas fa-window-close" aria-hidden="true"></i>
                                                                        {{alertMsg}}
                                                                  </div>
                                                            </div>
                                          </div>
                                    </div>
                                    <!--/.Panel-->

                              </div>
                              <!--Grid column-->

                        </div>


                  </div>

                  <div class="modal-footer">



                  </div>
            </div>
      </div>



</div>


<div mdbModal class="modal fade " id="scrollDocket" tabindex="-1" 
role="dialog" aria-labelledby="scrollDocketLabel"  #scrollframe="mdbModal">
      <div class="modal-dialog  modal-dialog-centered modal-lg" role="document">
            <div class="modal-content scrollmodalContent">

                  <!--Header-->
                  <div class="modal-header  darken-3 justify-content-center heading ">
                        <h4 class="title text-uppercase font-weight-bold ">
                              {{modalDocketHeader}}
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="scrollframe.hide()">
                              <span aria-hidden="true">&times;</span>
                        </button>
                  </div>
                  <!--Body-->
                  <div class="modal-body scrollmodalbody" >                

                        <div class="row d-flex justify-content-center" >

                              <div class="col-lg-12 col-md-12 waves-light" mdbWavesEffect>
                                    <!--Panel-->
                                    <div class="card justify-content-center ">
                                          <div class="card-header font-weight-normal" style="background: none; border: none; text-align: left;">
                                                <h5 class="font-weight-normal ">
                                                      {{modalDocketSubHeading}}
                                                </h5>
                                          </div>

                                          <div class="card-block" >
                                                <div class="col mx-1 wow fadeInUp "> 

                                                      <form class="form" #contactusform="ngForm" 
                                                      (ngSubmit)="contactusform.form.valid && onSubmit()" novalidate>
                                                            <div class="form-group row">
                                                                  <label for="clientname" class="col-sm-4 col-form-label">
                                                                        <span style="color: red">*</span>
                                                                        Client/Project Name:
                                                                  </label>
                                                                  <div class="col-sm-8">
                                                                        <input type="text" name="clientname" class="form-control" 
                                                                        placeholder="Client/Project Name" [(ngModel)]="contactmodel.clientname"
                                                                         #clientname="ngModel" required  autocomplete="off"  maxlength="200" pattern="^[0-9a-zA-Z''-'\s]{1,100}$"/>


                                                                        <span class="text-danger" *ngIf="(clientname.touched || contactusform.submitted) && (clientname.errors?.required || clientname.errors?.pattern)">
                                                                             Valid ClientName is required
                                                                        </span>

                                                                  </div>
                                                            </div>

                                                            <div class="form-group row">
                                                                  <label for="clientmarket" class="col-sm-4 col-form-label">
                                                                        <span style="color: red">*</span>
                                                                        Client’s Market:
                                                                  </label>
                                                                  <div class="col-sm-8">
                                                                        <select class="form-control" name="clientmarket" [(ngModel)]="contactmodel.clientmarket" #clientmarket="ngModel" required autocomplete="off" >
                                                                              <option value="">Select Client Market
                                                                              </option> 
                                                                                  
                                                                              <option *ngFor="let cm of clientmarketlist" value="{{cm.GeoId}}">
                                                                                    {{cm.GeoDesc}}
                                                                              </option>   
                                                                        </select>

                                                                        <span class="text-danger" *ngIf="(clientmarket.touched || contactusform.submitted) && clientmarket.errors?.required">
                                                                              Please select valid Clientmarket
                                                                        </span>

                                                                  </div>
                                                            </div>
                                                            <div class="form-group row">
                                                                  <label for="clientindustry" class="col-sm-4 col-form-label">
                                                                        <span style="color: red">*</span>
                                                                        Client’s Industry:
                                                                  </label>
                                                                  <div class="col-sm-8">
                                                                        <select class="form-control" name="clientindustry" [(ngModel)]="contactmodel.clientindustry" #clientindustry="ngModel" required autocomplete="off" >
                                                                              <option value="">Select Client Industry
                                                                              </option> 
                                                                                  
                                                                              <option *ngFor="let ci of clientindustrylist" value="{{ci.IgId}}">
                                                                                    {{ci.IgDesc}}
                                                                              </option>   
                                                                        </select>

                                                                        <span class="text-danger" *ngIf="(clientindustry.touched || contactusform.submitted) && clientindustry.errors?.required">
                                                                              Please select valid Clientindustry
                                                                        </span>

                                                                  </div>
                                                            </div>
                                                            <div class="form-group row">
                                                                  <label for="usecase" class="col-sm-4 col-form-label">
                                                                        <span style="color: red">*</span>
                                                                        Use Case:
                                                                  </label>
                                                                  <div class="col-sm-8">
                                                                        <select class="form-control" name="usecase" [(ngModel)]="contactmodel.usecase" #usecase="ngModel" required autocomplete="off" >
                                                                              <option value="">Select Usecase</option> 
                                                                               
                                                                              <option *ngFor="let uc of usecaselist" value="{{uc.UseCaseId}}">
                                                                                    {{uc.UseCaseDesc}}
                                                                              </option>   
                                                                        </select>


                                                                        <span class="text-danger" *ngIf="(usecase.touched || contactusform.submitted) && usecase.errors?.required">
                                                                              Please select valid Usecase
                                                                        </span>
                                                                  </div>
                                                            </div>
                                                            <div class="form-group row">
                                                                  <label for="oppurtunityId" class="col-sm-4 col-form-label">
                                                                        <span style="color: red">*</span>
                                                                        Opportunity ID (OM/MMS):
                                                                  </label>
                                                                  <div class="col-sm-8">
                                                                        <input type="tel" name="oppurtunityId" class="form-control" 
                                                                        placeholder="[OM/MMS ID] " [(ngModel)]="contactmodel.oppurtunityId"
                                                                         #oppurtunityId="ngModel" required  autocomplete="off"  
                                                                         maxlength="10" data-rule-maxlength="10"  pattern="\d{10}" 
                                                                         />


                                                                        <span class="text-danger" *ngIf="(oppurtunityId.touched || contactusform.submitted) && (oppurtunityId.errors?.required || oppurtunityId.errors?.pattern)">
                                                                        A valid 10 digit Opportunity ID must be entered . 
                                                                        </span>

                                                                  </div>
                                                            </div>
                                                            <div class="form-group row">
                                                                  <label for="dealValue" class="col-sm-4 col-form-label">
                                                                        <span style="color: red">*</span>
                                                                        Deal Value:
                                                                  </label>
                                                                  <div class="col-sm-8">
                                                                        <input type="text" name="dealValue" class="form-control" 
                                                                        placeholder="Deal Value" [(ngModel)]="contactmodel.dealValue"
                                                                         #dealValue="ngModel" required  autocomplete="off"  maxlength="200" pattern="^[0-9a-zA-Z''-'\s]{1,100}$"
                                                                         
                                                                         />


                                                                        <span class="text-danger" *ngIf="(dealValue.touched || contactusform.submitted) && (dealValue.errors?.required || dealValue.errors?.pattern)">
                                                                             Valid Deal Value  is required
                                                                        </span>

                                                                  </div>
                                                            </div>
                                                            <div class="form-group row mb-1">
                                                                  <label for="additionalinfo" class="col-sm-4 col-form-label">Additional
                                                                        Information:
                                                                  </label>
                                                                  <div class="col-sm-8">
                                                                        <textarea class="form-control" name="additionalinfo" rows="3" 
                                                                        placeholder="Additional Information" [(ngModel)]="contactmodel.additionalinfo" 
                                                                        maxlength="2000" autocomplete="off">
                                                                         </textarea>
                                                                  </div>
                                                            </div>

                                                            <div id="success" class="toast-alert alert-success hide mt-3 " role="alert" data-delay="1000" data-autohide="true" aria-live="assertive" aria-atomic="true">


                                                                  <div class="toast-body">
                                                                        <i class="fa fa-check" aria-hidden="true"></i>
                                                                        {{alertMsg}}
                                                                  </div>
                                                            </div>

                                                            <div id="filedownloadsuccess" class="toast-alert alert-info hide mt-3 " role="alert" 
                                                            aria-live="assertive" aria-atomic="true" data-autohide="false" *ngIf="showFileDownloadInfo">
                                                                  
                                                                  <div class="toast-body">
                                                                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                                        {{alertMsg}}
                                                                  </div>
                                                            </div>
                                                            <div id="error" class="toast-alert alert-danger hide mt-3" role="alert" data-delay="5000" data-autohide="true" aria-live="assertive" aria-atomic="true">

                                                                  <div class="toast-body">
                                                                        <i class="fas fa-window-close" aria-hidden="true"></i>
                                                                        {{alertMsg}}
                                                                  </div>
                                                            </div>


                                                            <div class="text-center" style="margin-top:-10px">
                                                                  <button type="submit" class="btn basebtn z-depth-5 text-uppercase contactbtn mr-3" [disabled]="buttondisable" disabled>

                                                                        <i class="fa fa-download"></i>
                                                                        Download

                                                                  </button>

                                                                  <button type="button" class="btn basebtn text-uppercase contactCancelbtn waves-effect z-depth-0 " (click)="formreset()">
                                                                        <i class="fas fa-window-close"></i>
                                                                        Reset

                                                                  </button>


                                                            </div>


                                                            
                                                            <div class="d-flex justify-content-center adjust" *ngIf="loading">



                                                                  <div class="loader " id="loader-4">

                                                                        <span></span>
                                                                        <span></span>
                                                                        <span></span>

                                                                  </div>
                                                            </div>




                                                      </form>

                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      </div>
</div>


<div mdbModal #frame="mdbModal" class="modal fade top" id="scrollDocket1" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true"  data-backdrop="true">
  <div class="modal-dialog modal-md modal-dialog-centered backdropFix" role="document">
    <!--Content-->
    <div class="modal-content text-center ">
      <!--Header-->
      <div class="modal-header  darken-3 justify-content-center heading" >
      
        <h4 class="title text-uppercase font-weight-bold ">
        Disclaimer
                        </h4>
      </div>

      <!--Body-->
      <div class="modal-body">      
        <h6 class=" text-sm-left iconColor mt-4 mr-5 ml-5">

            Please note the contents of the pre-requisite docket are different for each ASD offerings
            (i.e. SAP S/4 HANA, SAP ECC, SAP BW, SAP APO). 
      </h6>
 <h6 class="text-sm-left iconColor mt-3 mr-5 ml-5">
 Kindly download the pre-requisite docket relevant for your scope of assessment. 
 Also, kindly make sure to download the fresh pre-requisite docket when commencing the setup 
 for the assessment since the contents of the docket are updated on a 
 periodic basis with new features.</h6>

 <h6 class="text-sm-left iconColor mt-3 mr-5 ml-5">
 Please feel free to reach out to the ASD Team at
 <a  href="mailto:asd.support@accenture.com"
         class="text-lowercase font-weight-bold"
          style="text-decoration:underline"> asd.support@accenture.com </a>
  in case any assistance  is required.</h6>
      </div>

      <!--Footer-->
      <div class="modal-footer justify-content-center">

      <button type="submit" class="btn basebtn z-depth-5 text-uppercase contactbtn mr-3"
      (click)="openScrollDocket()" data-dismiss="modal"  data-target="#scrollDocket">

            <i class="fa fa-check"></i>
            Proceed

      </button>


      
      </div>
    </div>
    <!--/.Content-->
  </div>
</div>